import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import { faCoffee } from '@fortawesome/free-solid-svg-icons'
// import { faStopCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faStopCircle)

// Vue.component('font-awesome-icon', FontAwesomeIcon)

// import { library } from '@fortawesome/fontawesome-svg-core';
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faStopCircle } from '@fortawesome/free-solid-svg-icons'
import { faPauseCircle } from '@fortawesome/free-solid-svg-icons'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { faPause } from '@fortawesome/free-solid-svg-icons'
import { faPlay } from '@fortawesome/free-solid-svg-icons'
import { faBell } from '@fortawesome/free-solid-svg-icons'
import { faUsers } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faClock } from '@fortawesome/free-solid-svg-icons'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { faTable } from '@fortawesome/free-solid-svg-icons'
import { faHistory } from '@fortawesome/free-solid-svg-icons'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { faAddressCard } from '@fortawesome/free-solid-svg-icons'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons'
import { faCreditCard } from '@fortawesome/free-solid-svg-icons'
import { faUserPlus } from '@fortawesome/free-solid-svg-icons'
import { faBan } from '@fortawesome/free-solid-svg-icons'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { faServer } from '@fortawesome/free-solid-svg-icons'
import { faSave } from '@fortawesome/free-solid-svg-icons'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons'
import { faCalendarWeek } from '@fortawesome/free-solid-svg-icons'
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import { faTools } from '@fortawesome/free-solid-svg-icons'
import { faGlobeAmericas } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faMinus } from '@fortawesome/free-solid-svg-icons'
import { faCloud } from '@fortawesome/free-solid-svg-icons'
import { faDatabase } from '@fortawesome/free-solid-svg-icons'
import { faArchive } from '@fortawesome/free-solid-svg-icons'
import { faStopwatch } from '@fortawesome/free-solid-svg-icons'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { faHdd } from '@fortawesome/free-solid-svg-icons'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { faListUl } from '@fortawesome/free-solid-svg-icons'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { faFolder } from '@fortawesome/free-solid-svg-icons';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons'
import { faUndoAlt } from '@fortawesome/free-solid-svg-icons'
import { faKey } from '@fortawesome/free-solid-svg-icons'
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons'
import { faLink } from '@fortawesome/free-solid-svg-icons'

import { faSlack } from '@fortawesome/free-brands-svg-icons'
import { faDigitalOcean } from '@fortawesome/free-brands-svg-icons'
import { faAws } from '@fortawesome/free-brands-svg-icons'
import { faGithub } from '@fortawesome/free-brands-svg-icons'
import { faWindows } from '@fortawesome/free-brands-svg-icons'

import { faFileAlt } from '@fortawesome/free-regular-svg-icons'
// import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons'
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons'
// import { faTimes } from '@fortawesome/free-regular-svg-icons'
import { faSquare } from '@fortawesome/free-regular-svg-icons'
import { faCircle as faCircleRegular } from '@fortawesome/free-regular-svg-icons'
import { faClock as faClockRegular } from '@fortawesome/free-regular-svg-icons'
import { faEye } from '@fortawesome/free-regular-svg-icons'
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import { faChartBar } from '@fortawesome/free-regular-svg-icons'
import { faLightbulb } from '@fortawesome/free-regular-svg-icons'
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';


// Solid
library.add(faStopCircle);
library.add(faPauseCircle);
library.add(faInfoCircle);
library.add(faPlusCircle);
library.add(faPause);
library.add(faPlay);
library.add(faBell);
library.add(faUsers);
library.add(faUser);
library.add(faClock);
library.add(faCog);
library.add(faSignOutAlt);
library.add(faTable);
library.add(faHistory);
library.add(faTrash);
library.add(faAngleLeft);
library.add(faAngleRight);
library.add(faAddressCard);
library.add(faLock);
library.add(faMobileAlt);
library.add(faSlack);
library.add(faCreditCard);
library.add(faUserPlus);
library.add(faBan);
library.add(faArrowDown);
library.add(faExclamationTriangle);
library.add(faCircleNotch);
library.add(faCaretDown);
library.add(faChevronDown);
library.add(faChevronUp);
library.add(faSpinner);
library.add(faServer);
library.add(faSave);
library.add(faTrashAlt);
library.add(faCalendar);
library.add(faCalendarDay);
library.add(faCalendarWeek);
library.add(faEllipsisH);
library.add(faTools);
library.add(faGlobeAmericas);
library.add(faPlus);
library.add(faMinus);
library.add(faCloud);
library.add(faDatabase);
library.add(faArchive);
library.add(faStopwatch);
library.add(faCalendarAlt);
library.add(faHdd);
library.add(faSearch);
library.add(faBars);
library.add(faCircle);
library.add(faListUl);
library.add(faDownload);
library.add(faHome);
library.add(faFile);
library.add(faFolder);
library.add(faShieldAlt);
library.add(faUndoAlt);
library.add(faKey);
library.add(faSyncAlt);
library.add(faLink);

// Brands
library.add(faSlack);
library.add(faDigitalOcean);
library.add(faAws);
library.add(faGithub);
library.add(faWindows);

// Regular
library.add(faFileAlt);
// library.add(faCalendarAlt);
library.add(faCheckCircle);
library.add(faTimesCircle);
// library.add(faTimes);
library.add(faSquare);
library.add(faCircleRegular);
library.add(faEye);
library.add(faEyeSlash);
library.add(faChartBar);
library.add(faLightbulb);
library.add(faClockRegular);
library.add(faQuestionCircle);

window.Vue.component('font-awesome-icon', FontAwesomeIcon);
window.Vue.config.productionTip = false;
